var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    attrs: {
      "role": "navigation"
    }
  }, [(_vm.breadcrumbAction) ? _c('polaris-unstyled-link', {
    staticClass: "Polaris-Breadcrumbs__Breadcrumb",
    attrs: {
      "url": _vm.breadcrumbAction.url
    }
  }, [_c('span', {
    staticClass: "Polaris-Breadcrumbs__Icon"
  }, [_c('polaris-icon', {
    attrs: {
      "source": _vm.chevronIcon
    }
  })], 1), _vm._v("\n        " + _vm._s(_vm.breadcrumbAction.content) + "\n    ")]) : _vm._e()], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0e45367e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e45367e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisBreadcrumbs.vue
// module id = 353
// module chunks = 0